import React, { useState } from 'react';
import { apiService } from '../../../../services/api';
import { CreateUnidadeMedidaData } from '../../../../types/unidadesMedida';
import { toast } from 'react-toastify';

interface QuickUnitFormProps {
  onSuccess: (newUnit: any) => void;
  onCancel: () => void;
}

const QuickUnitForm: React.FC<QuickUnitFormProps> = ({
  onSuccess,
  onCancel
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [newUnit, setNewUnit] = useState<CreateUnidadeMedidaData>({
    codigo: '',
    nome: '',
    abreviacao: ''
  });

  const handleSubmit = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!newUnit.codigo.trim()) {
      toast.error('O código da unidade é obrigatório');
      return;
    }

    try {
      setIsSubmitting(true);
      console.log('DEBUG [QuickUnitForm] - Enviando dados para criar unidade:', newUnit);
      const response = await apiService.createUnidadeMedida(newUnit);
      console.log('DEBUG [QuickUnitForm] - Resposta da criação:', response);

      if (response && response.data) {
        setNewUnit({ codigo: '', nome: '', abreviacao: '' });
        onSuccess(response.data);
      }
    } catch (error: any) {
      console.error('Erro ao criar unidade:', error);
      toast.error(error.message || 'Erro ao criar unidade de medida');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="quick-status-form-wrapper">
      <div className="alert alert-info d-flex align-items-center mb-3">
        <i className="ti ti-info-circle me-2"></i>
        <span>Cadastro rápido - Adicione uma nova unidade de medida</span>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">
            Código <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            value={newUnit.codigo}
            onChange={(e) => setNewUnit(prev => ({ ...prev, codigo: e.target.value }))}
            placeholder="Ex: kg, m3, unidade"
            autoFocus
          />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Abreviação</label>
          <input
            type="text"
            className="form-control"
            value={newUnit.abreviacao || ''}
            onChange={(e) => setNewUnit(prev => ({ ...prev, abreviacao: e.target.value }))}
            placeholder="Ex: kg, m³"
          />
        </div>

        <div className="col-12 mb-3">
          <label className="form-label">Nome</label>
          <input
            type="text"
            className="form-control"
            value={newUnit.nome || ''}
            onChange={(e) => setNewUnit(prev => ({ ...prev, nome: e.target.value }))}
            placeholder="Ex: Quilogramas, Metro Cúbico"
          />
        </div>

        <div className="col-12">
          <div className="d-flex gap-2 justify-content-end pt-2 border-top">
            <button
              type="button"
              className="btn btn-light"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              <i className="ti ti-x me-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Salvando...
                </>
              ) : (
                <>
                  <i className="ti ti-check me-1"></i>
                  Salvar Unidade
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickUnitForm;
